import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const nav = useNavigate();
    const submit = async (e) => {
        e.preventDefault(); setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) { toast.success("Bienvenido"); nav("/cuenta"); } else toast.error(res.error);
    };
    const inp = "w-full border border-sandLight bg-white rounded-md px-4 py-3 text-sm outline-none focus:border-ink";
    return (
        <div className="mx-auto max-w-md px-4 py-16">
            <p className="text-eyebrow">Cuenta</p>
            <h1 className="font-display text-4xl mt-2 mb-8">Iniciar sesión</h1>
            <form onSubmit={submit} className="space-y-4">
                <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inp} data-testid="login-email" />
                <input required type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className={inp} data-testid="login-password" />
                <button disabled={loading} data-testid="login-submit" className="btn-ink w-full">{loading ? "Ingresando…" : "Ingresar"}</button>
            </form>
            <p className="text-sm text-ink/60 mt-6 text-center">¿No tienes cuenta? <Link to="/registro" className="text-ink underline">Regístrate</Link></p>
        </div>
    );
}
